import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button } from "antd";
import RSEEditor from "react-simple-code-editor";
import Prism from "prismjs";

const FormColProperties = ({ formData, onFinish }) => {
    const [editorValue, setEditorValue] = useState(formData.style);
    const [form] = Form.useForm(null);

    useEffect(() => {
        form.setFieldsValue({
            name: formData.name,
            style: formData.style,
            xl: formData.width.xl,
            lg: formData.width.lg,
            md: formData.width.md,
            sm: formData.width.sm,
            xs: formData.width.xs,
        });
        setEditorValue(formData.style);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    const handleEditorValueChange = (value) => {
        setEditorValue(value);
    };

    const handleFormFinish = (values) => {
        onFinish({
            ...values,
            style: editorValue,
        });
    };

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };
    const tailLayout = {
        wrapperCol: { offset: 8, span: 16 },
    };

    return (
        <Form {...layout} form={form} onFinish={handleFormFinish}>
            <Form.Item
                label="Row Name"
                name="name"
                rules={[{ required: true, message: "Please input row name!" }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="xl"
                name="xl"
                rules={[{ required: true, message: "Please input xl!" }]}
            >
                <InputNumber />
            </Form.Item>
            <Form.Item
                label="lg"
                name="lg"
                rules={[{ required: true, message: "Please input lg!" }]}
            >
                <InputNumber />
            </Form.Item>
            <Form.Item
                label="md"
                name="md"
                rules={[{ required: true, message: "Please input md!" }]}
            >
                <InputNumber />
            </Form.Item>
            <Form.Item
                label="sm"
                name="sm"
                rules={[{ required: true, message: "Please input sm!" }]}
            >
                <InputNumber />
            </Form.Item>
            <Form.Item
                label="xs"
                name="xs"
                initialValue={formData.width.xs}
                rules={[{ required: true, message: "Please input xs!" }]}
            >
                <InputNumber />
            </Form.Item>
            <Form.Item label="Style">
                <RSEEditor
                    textareaClassName="htmlCSSEditor"
                    padding={10}
                    value={editorValue}
                    onValueChange={handleEditorValueChange}
                    highlight={(code) =>
                        Prism.highlight(code, Prism.languages.css, "css")
                    }
                    style={{
                        fontFamily: '"Fira code", "Fira Mono", monospace',
                        fontSize: 12,
                        border: "1px solid #ccc",
                    }}
                />
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
            </Form.Item>
        </Form>
    );
};

export default FormColProperties;
